import React, { Component } from "react";
import { currency } from './../../../../../helpers/';

class MembershipPackagePrice extends Component {
    basePackage = price => {

        price = currency.convert( price );

        return (
            <section className="padding-bottom">
                <div className="bundle-price currency-bundle">{ price.substring( 0, 1 ) }</div>
                <div className="bundle-price">{ price }</div>
                <div className="bundle-vat">{ `(excludes ${ currency.taxType() })` }</div>
            </section>
        );
    };

    promotionalPackage = ( basePrice, promotionalPrice ) => {

        basePrice = currency.convert( basePrice );
        promotionalPrice = currency.convert( promotionalPrice );
        const currencySign = basePrice.substring( 0, 1 );

        return (
            <div className="prices side-by-side-compare">
                <div className="row">
                    <div className="col-xs-6">
                        <div className="price-regular">
                            <p className="p-tag title-uppercase">Regular Price</p>
                            <div className="price"><span className="currency">{ currencySign }</span>{ basePrice.substring( 1, basePrice.length ) }</div>
                        </div>
                        <div className="vat-info">{ `(excludes ${ currency.taxType() })` }</div>
                    </div>
                    <div className="col-xs-6">
                        <div className="price-promoted">
                            <p className="p-tag title-uppercase">Now Only</p>
                            <div className="price"><span className="currency">{ currencySign }</span>{ promotionalPrice.substring( 1, promotionalPrice.length ) }</div>
                        </div>
                        <div className="vat-info">{ `(excludes ${ currency.taxType() })` }</div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { basePrice, promoPrice } = this.props;

        if( basePrice === promoPrice ) return this.basePackage( basePrice );
        if( basePrice !== promoPrice ) return this.promotionalPackage( basePrice, promoPrice );
    };
}

export default MembershipPackagePrice;



// WEBPACK FOOTER //
// src/client/components/common/transactions/membership/unused/MembershipPackagePrice.js